import React, { useState } from 'react';
import { motion } from 'framer-motion';
import PageWrapper from '../components/layout/PageWrapper';
import FAQSearch from '../components/faq/FAQSearch';
import FAQSection from '../components/faq/FAQSection';
import { categories } from '../data/faqData';

const FAQPage: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState('');
  
  const filteredCategories = categories.map(category => ({
    ...category,
    items: category.items.filter(item => 
      item.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.answer.toLowerCase().includes(searchQuery.toLowerCase())
    )
  })).filter(category => category.items.length > 0);

  return (
    <PageWrapper>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="min-h-screen bg-gray-50 py-12"
      >
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <motion.h1 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-4xl font-bold text-gray-900 mb-4"
            >
              Frequently Asked Questions
            </motion.h1>
            <motion.p 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 }}
              className="text-lg text-gray-600 max-w-2xl mx-auto"
            >
              Find answers to common questions about our services, booking process, and more.
            </motion.p>
          </div>

          <FAQSearch 
            value={searchQuery}
            onChange={setSearchQuery}
            className="mb-12"
          />

          <div className="space-y-10">
            {filteredCategories.map((category) => (
              <FAQSection
                key={category.id}
                title={category.title}
                icon={category.icon}
                items={category.items}
              />
            ))}
          </div>

          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="mt-16 text-center border-t border-gray-200 pt-12"
          >
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Still have questions?
            </h2>
            <p className="text-gray-600 mb-8">
              Can't find what you're looking for? We're here to help.
            </p>
            <button
              className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-lg shadow-sm text-white bg-airbnb-red hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-airbnb-red transition-colors duration-200"
            >
              Contact Support
            </button>
          </motion.div>
        </div>
      </motion.div>
    </PageWrapper>
  );
};

export default FAQPage;